import { AnyAction } from 'redux';
import { isBrightColor } from '@/utils/colors/isBrightColor';
import { getAppearance } from '@/model/draft/getAppearance';
import { getLastTextConfiguration } from '@/model/draft/getLastTextConfiguration';
import { ensureFontIsAddedToDocumentAction } from '@/redux/core/actions/ensureFontIsAddedToDocumentAction';
import { getDefaultFont } from '@/redux/core/getters/getDefaultFont';
import { getFonts } from '@/redux/core/getters/getFonts';
import { getDraftDispatch } from '@/redux/draft/draftDispatch';
import { getDraft } from '@/redux/draft/getters/getDraft';
import { Thunk } from '@/redux/types';
import { addPlaceholderTextAction } from '@/components/draft/draftState/actions/addPlaceholderTextAction';

export const addPlaceholderTextConfigurationAction: Thunk<Promise<void>, AnyAction> = async (
  dispatch,
  getState
) => {
  const state = getState();

  const lastTextConfiguration = getLastTextConfiguration(getDraft(state));
  const font = lastTextConfiguration?.text.style.font || getDefaultFont(getFonts(state));

  const color =
    lastTextConfiguration?.printColors[0].fill ||
    (isBrightColor(getAppearance(getDraft(state)).colors[0].value) ? '#000000' : '#FFFFFF');

  const loadedFont = await dispatch(ensureFontIsAddedToDocumentAction(font));

  getDraftDispatch(state)(addPlaceholderTextAction('Placeholder', loadedFont, color));
};
